import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticImprint = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findImprintSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useImprintQuery {
		squidex {
			findImprintSingleton {
				id
				data {
					seo {
						de {
							title
							description
						}
					}

					header {
						de {
							title
						}
					}

					content {
						de {
							title
							text
						}
					}

					labels {
						de {
							legalForm
							lineOfBusiness
							chambers
							regulators
							tradeRegulations
							headquarters
							corporateRegisterCourt
							corporateRegisterNr
							valueAddedTaxNr
							dataProcessingRegisterNr
						}
					}

					items {
						de {
							title
							text
						}
					}
				}
			}
		}
	}
`;
